/* eslint-disable */
import { LOCK_KEY } from '../../../utils/devLock';

// ============================================================
// devsBarModel — the vocabulary of the Developments bar (CLB-079, David's v6).
// One place for: the six stages (live Shell v3 palette — decision D2; label
// "Done" kept — D1), the axes and their order, the sort list (live six — D3),
// and the small text helpers the bar, the popovers and the chips share.
// ============================================================

// c = the live --st-* token; t / d = the tint and the dark ink of the pill (live palette, shell-v3-map).
export const STAGES = [
  { key: 'Drawing stage',          name: 'Drawing',        c: 'var(--st-draw)',  t: '#fbf3dc', d: '#7a5c10' },
  { key: 'Hand made sample stage', name: 'Hand made',      c: 'var(--st-hand)',  t: '#ecf1f8', d: '#34506f' },
  { key: 'Color sample stage',     name: 'Colour sample',  c: 'var(--st-color)', t: '#faf0e4', d: '#84502e' },
  { key: '_done',                  name: 'Done',           c: 'var(--st-done)',  t: '#eaf5ef', d: '#2d6648' },
  { key: LOCK_KEY,                 name: 'Moved to order', c: 'var(--st-lock)',  t: '#fdf1e8', d: '#8a4f26' },
  { key: '_stopped',               name: 'Stopped',        c: 'var(--st-stop)',  t: '#f3eff2', d: '#5c4a5a' },
];
export const STAGE_BY_KEY = Object.fromEntries(STAGES.map((s) => [s.key, s]));
export const STAGE_KEYS = STAGES.map((s) => s.key);
export const FLAG_KEYS = ['_no_image', '_imported'];
export const FLAGS = [{ value: '_no_image', label: 'No image' }, { value: '_imported', label: 'Imported' }];

// The three axes that stay on the bar — swap here (David's BAR_AXES).
export const BAR_AXES = ['designer', 'season', 'factory'];
export const AXIS_NAME = { sunOptic: 'Line', material: 'Material', shape: 'Shape', decision: 'Decision', procurement: 'Procurement', flag: 'Flags', designer: 'Designer', season: 'Season', factory: 'Factory' };
// Filters popover order: the rest first, the three bar axes last under "Also on the bar".
export const POP_AXES = ['sunOptic', 'material', 'shape', 'decision', 'procurement', 'flag', 'designer', 'season', 'factory'];
// Chips: the bar axes first (as in the prototype), then the others.
export const CHIP_AXES = ['designer', 'season', 'factory', 'sunOptic', 'material', 'shape', 'decision', 'procurement', 'flag'];
export const FLAG_AXIS = 'flag';

export const SORT_ITEMS = [
  { key: 'newest', label: 'Newest first' }, { key: 'oldest', label: 'Oldest first' }, { key: 'updated', label: 'Recently updated' },
  { key: 'designer_az', label: 'Designer A → Z' }, { key: 'type_az', label: 'Type A → Z' }, { key: 'devnum_az', label: 'Dev # A → Z' },
];
export const SORT_SHORT = { newest: 'Newest', oldest: 'Oldest', updated: 'Updated', designer_az: 'Designer', type_az: 'Type', devnum_az: 'Dev #' };

export const fmt = (n) => (n == null ? '–' : Number(n).toLocaleString('en-US'));
export const plural = (n, w) => `${fmt(n)} ${w}${n === 1 ? '' : 's'}`;
const EMPTY = new Set();

// The selected values of one axis as an array. The Flags axis lives inside devFilters.status.
export function axisValues(devFilters, axis) {
  if (axis === FLAG_AXIS) return FLAG_KEYS.filter((k) => devFilters?.status?.has(k));
  return Array.from(devFilters?.[axis] || EMPTY);
}
export const stageValues = (devFilters) => STAGE_KEYS.filter((k) => devFilters?.status?.has(k));

export function labelOf(opts, axis, v) {
  if (axis === FLAG_AXIS) return (FLAGS.find((f) => f.value === v) || {}).label || v;
  const o = (opts?.[axis] || []).find((x) => x.value === v);
  return o ? o.label : v;
}
export function summary(opts, devFilters, axis) {
  const s = axisValues(devFilters, axis);
  return s.length ? labelOf(opts, axis, s[0]) + (s.length > 1 ? ` +${s.length - 1}` : '') : '';
}
